import { render, staticRenderFns } from "./SimulationsLegacyTab.vue?vue&type=template&id=c0954520&scoped=true&"
import script from "./SimulationsLegacyTab.vue?vue&type=script&lang=js&"
export * from "./SimulationsLegacyTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0954520",
  null
  
)

export default component.exports